// React
import React from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ListProposals } from './ListProposals';
import { ReportsInjection } from '../../../containers/reportsInjection';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

export const ModalProposals = ({
  isOpen,
  toggle,
  customer,
  handleGenerateReport,
}) => {
  const { proposalGetAssociates, proposalsAssociates } = ReportsInjection();

  useEffect(() => {
    if (customer.hashid) {
      proposalGetAssociates(customer.hashid);
    }
  }, [customer, proposalGetAssociates]);
  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        toggle();
      }}
      zIndex={10000}
      backdrop={'static'}
      id="staticBackdrop"
      size="xl"
      centered
    >
      <ModalHeader>
        <p>Propostas de {customer.name}</p>
      </ModalHeader>
      <ModalBody>
        <ListProposals
          idCustomer={customer.hashid}
          proposalsAssociates={proposalsAssociates}
          handleGenerateReport={handleGenerateReport}
        />
      </ModalBody>
      <ModalFooter>
        <div className="hstack gap-2 justify-content-end mb-3 me-3">
          <Link
            to="#"
            className="btn btn-primary mt-3"
            onClick={() => toggle()}
          >
            Fechar
          </Link>
        </div>
      </ModalFooter>
    </Modal>
  );
};
